import {
  ADD_SERVICER,
  UPDATE_SERVICER,
  LOAD_SERVICERS,
  LOAD_FORMS,
  ADD_FORM,
  UPDATE_FORM
} from '../actions/types';

const initialState = {
  servicers: [],
  forms: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FORM:
      return {
        ...state,
        forms: state.forms.map(form => {
          if (form.id === action.payload.id) {
            return action.payload;
          }
          return form;
        })
      };
    case ADD_FORM:
      return {
        ...state,
        forms: [...state.forms, action.payload]
      };
    case ADD_SERVICER:
      return {
        ...state,
        servicers: [...state.servicers, action.payload]
      };
    case UPDATE_SERVICER:
      return {
        ...state,
        servicers: state.servicers.map(servicer => {
          if (servicer.id === action.payload.id) {
            return action.payload;
          } else {
            return servicer;
          }
        })
      };
    case LOAD_SERVICERS:
      return {
        ...state,
        servicers: action.payload
      };
    case LOAD_FORMS:
      return {
        ...state,
        forms: action.payload
      };
    default:
      return state;
  }
}
